export const CREATE_OWNER_PAYMENT_SCHEDULE = "CREATE_OWNER_PAYMENT_SCHEDULE";
export const FETCH_OWNER_PAYMENT_SCHEDULES = "FETCH_OWNER_PAYMENT_SCHEDULES";
export const FETCH_OWNER_PAYMENT_SCHEDULE = "FETCH_OWNER_PAYMENT_SCHEDULE";
export const EDIT_OWNER_PAYMENT_SCHEDULE = "EDIT_OWNER_PAYMENT_SCHEDULE";
export const DELETE_OWNER_PAYMENT_SCHEDULE = "DELETE_OWNER_PAYMENT_SCHEDULE";
export const CREATE_OWNER_PAYMENT_SCHEDULE_BULK =
  "CREATE_OWNER_PAYMENT_SCHEDULE_BULK";
